const en = {
    call_me_back_title: 'Call me back',
    call_me_back_daily_request: 'Daily requests',
    call_me_back_history_btn: 'View history',
    call_me_back_select_recipiant: 'Select recipiant',
    call_me_back_contacts: 'Your contacts',
    call_me_back_send_request: 'Send request to',
    call_me_back_mobile_no: 'Mobile Number',
    call_me_back_wrong_phone_format: 'Invalid number',
    call_me_back_confirm: 'Confirm',
    call_me_back_success_title: 'Success!',
    call_me_back_success_description: 'Your request was sent successfully',
    call_me_back_error_title: 'Oops, there\'s a problem!',
    call_me_back_default_error: 'Something went wrong, please try your request again',
    call_me_back_history_empty_text: 'You have no previous request sent to Vodafone friends.',
    call_me_back_history_header: 'History',
    call_me_back_service_description: 'Call me back is a service through which you can send call request towards your Vodafone friends if you have a lower balance than ',
    call_me_back_service_amount: '27 ALL',
    call_me_back_button: 'Back',
}

export default en
